angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateBadgeController',
	function(
		$rootScope, $scope, $state, $stateParams, $timeout,
		$confirm,
		InvitationListComunicateService
	) {

	$scope.id              = $stateParams.id;
	$scope.event_id        = $stateParams.event_id;

	$rootScope.getInvitationList($stateParams.id);

	$rootScope.getEvent( $stateParams.event_id );

	$scope.changeInvitationListBadge = function() {
		$rootScope.showLoader();
		$rootScope.invitationListData.badge_changed = true;
	};

	$scope.changeInvitationListBadgeLogo = function() {
		$rootScope.showLoader();
		$rootScope.invitationListData.badge_logo_changed = true;
	};

	$scope.$watch('$root.invitationListData.badge', function() {
		$rootScope.hideLoader();
	});

	$scope.$watch('$root.invitationListData.badge_logo', function() {
		$rootScope.hideLoader();
	});


	$scope.checkBadgeForm = function() {
		if ( !$scope.forms.badge_form.$invalid &&
			 $rootScope.invitationListData &&
			 $rootScope.invitationListData.badge && $rootScope.invitationListData.badge.dataURL != '' ) {
			return false;
		}
		return true;
	};

	$scope.saveBadge = function()
	{
		if ( $rootScope.invitationListData.badge && $rootScope.invitationListData.badge.dataURL ) {
			$rootScope.invitationListData.badge = $rootScope.invitationListData.badge.dataURL;
		} else {
			$rootScope.invitationListData.badge = '';
		}

		if ( $rootScope.invitationListData.badge_logo.dataURL ) {
			$rootScope.invitationListData.badge_logo = $rootScope.invitationListData.badge_logo.dataURL;
		} else {
			$rootScope.invitationListData.badge_logo = '';
		}

		var invitationListData = angular.copy($rootScope.invitationListData);

		InvitationListComunicateService
			.updateBadge(invitationListData)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					data.badge = {
						dataURL: data.badge,
						resized: {
							dataURL: data.badge
						}
					};

					data.badge_logo = {
						dataURL: data.badge_logo,
						resized: {
							dataURL: data.badge_logo
						}
					};

					$rootScope.invitationListData = data;

					$scope.showSuccessMsg('Badge aggiornato con successo!', '');
				}

			});
	};

	$scope.previewBadge = function() {
		InvitationListComunicateService.previewBadge( $rootScope.invitationListData.id );
	};

	$scope.removeBadge = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine del badge?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();
			InvitationListComunicateService
				.deleteBadge( $stateParams.id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.badge = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine Badge eliminata con successo!', '');
					}
				});

		}, function() { });
	};

	$scope.removeBadgeLogo = function() {
		$confirm({
			title: 'Sei sicuro di voler eliminare il logo dal badge?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();
			InvitationListComunicateService
				.deleteBadgeLogo( $stateParams.id  )
				.then(function(data) {

					$scope.hideLoader();

					if ( data ) {

						$rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.badge_logo = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Logo Badge eliminato con successo!', '');
					}
				});

		}, function() { });
	};

	$scope.badgePreviewUrl = '';
	$scope.previewBadge = function()
	{
		InvitationListComunicateService
			.previewBadge( $rootScope.invitationListData.id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.badgePreviewUrl = data.badge + '?time=' + (new Date()).getTime();
				}
			});
	};
});
